// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * GDS API Internal
 * <!-- used by swagger --> An Internal API to manage Aura Graph Analytics Sessions. Intended to be used by other components inside Aura. These endpoints require mtls and are not exposed to the public.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalendpointsSessionDetailsStatus } from './InternalendpointsSessionDetailsStatus';
import {
  InternalendpointsSessionDetailsStatusFromJSON,
  InternalendpointsSessionDetailsStatusFromJSONTyped,
  InternalendpointsSessionDetailsStatusToJSON,
  InternalendpointsSessionDetailsStatusToJSONTyped,
} from './InternalendpointsSessionDetailsStatus';
import type { InternalendpointsSessionDetailsSpec } from './InternalendpointsSessionDetailsSpec';
import {
  InternalendpointsSessionDetailsSpecFromJSON,
  InternalendpointsSessionDetailsSpecFromJSONTyped,
  InternalendpointsSessionDetailsSpecToJSON,
  InternalendpointsSessionDetailsSpecToJSONTyped,
} from './InternalendpointsSessionDetailsSpec';

/**
 *
 * @export
 * @interface InternalendpointsSessionDetails
 */
export interface InternalendpointsSessionDetails {
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof InternalendpointsSessionDetails
   */
  annotations?: { [key: string]: string };
  /**
   *
   * @type {string}
   * @memberof InternalendpointsSessionDetails
   */
  createdAt?: string;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof InternalendpointsSessionDetails
   */
  labels?: { [key: string]: string };
  /**
   *
   * @type {string}
   * @memberof InternalendpointsSessionDetails
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsSessionDetails
   */
  priority?: string;
  /**
   *
   * @type {InternalendpointsSessionDetailsSpec}
   * @memberof InternalendpointsSessionDetails
   */
  spec?: InternalendpointsSessionDetailsSpec;
  /**
   *
   * @type {InternalendpointsSessionDetailsStatus}
   * @memberof InternalendpointsSessionDetails
   */
  status?: InternalendpointsSessionDetailsStatus;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsSessionDetails
   */
  version?: string;
}

/**
 * Check if a given object implements the InternalendpointsSessionDetails interface.
 */
export function instanceOfInternalendpointsSessionDetails(
  value: object,
): value is InternalendpointsSessionDetails {
  return true;
}

export function InternalendpointsSessionDetailsFromJSON(
  json: any,
): InternalendpointsSessionDetails {
  return InternalendpointsSessionDetailsFromJSONTyped(json, false);
}

export function InternalendpointsSessionDetailsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InternalendpointsSessionDetails {
  if (json == null) {
    return json;
  }
  return {
    annotations: json['annotations'] == null ? undefined : json['annotations'],
    createdAt: json['created_at'] == null ? undefined : json['created_at'],
    labels: json['labels'] == null ? undefined : json['labels'],
    name: json['name'] == null ? undefined : json['name'],
    priority: json['priority'] == null ? undefined : json['priority'],
    spec:
      json['spec'] == null
        ? undefined
        : InternalendpointsSessionDetailsSpecFromJSON(json['spec']),
    status:
      json['status'] == null
        ? undefined
        : InternalendpointsSessionDetailsStatusFromJSON(json['status']),
    version: json['version'] == null ? undefined : json['version'],
  };
}

export function InternalendpointsSessionDetailsToJSON(
  json: any,
): InternalendpointsSessionDetails {
  return InternalendpointsSessionDetailsToJSONTyped(json, false);
}

export function InternalendpointsSessionDetailsToJSONTyped(
  value?: InternalendpointsSessionDetails | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    annotations: value['annotations'],
    created_at: value['createdAt'],
    labels: value['labels'],
    name: value['name'],
    priority: value['priority'],
    spec: InternalendpointsSessionDetailsSpecToJSON(value['spec']),
    status: InternalendpointsSessionDetailsStatusToJSON(value['status']),
    version: value['version'],
  };
}
